import { io } from 'socket.io-client';
import { ambient } from '../constants/ambient';

const basePath = ambient === "production" ? 'https://intranet-backend-mercadotica.herokuapp.com/' : 'http://localhost:5000';

const socket = io(basePath, { autoConnect: false });

export default socket;
